import Typography from "antd/lib/typography";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ISkillItem, ISkillLevelItem } from "@sol/sdk";
import { Spin } from "@sol/uikit/feedback/Spin/Spin";

import styles from "./SkillsList.module.css";
import { SkillsListItem } from "./SkillsListItem";

type Props = {
    items?: ISkillItem[];
    onSelect?: (item: ISkillItem) => void;
    selectedItem?: string;
    selectedLevels?: ISkillLevelItem[];
    isLoading?: boolean;
    showLevelBadges?: boolean;
    className?: string;
};

const SkillsList = ({
    items = [],
    onSelect,
    selectedItem,
    selectedLevels,
    showLevelBadges,
    isLoading = false,
    className,
}: Props) => {
    const [t] = useTranslation();

    return (
        <div className={clsx("flex min-h-0 flex-col px-ant-xs py-0", styles.skillsList, className)}>
            <Typography.Text className="inline-flex justify-center p-ant">
                {t("component.shared.SkillsList.label")}
            </Typography.Text>
            <Spin spinning={isLoading}>
                <ul data-cy="skills-list" className="m-0 flex h-full min-h-0 flex-col overflow-y-auto p-0">
                    {items.map(item => {
                        const itemId = item["@id"];

                        return (
                            <SkillsListItem
                                key={itemId}
                                item={item}
                                selected={selectedItem === itemId}
                                onClick={() => {
                                    onSelect?.(item);
                                }}
                                selectedLevels={selectedLevels}
                                showLevelBadges={showLevelBadges}
                            />
                        );
                    })}
                </ul>
            </Spin>
        </div>
    );
};

export default SkillsList;
